import { cva } from '@/styled-system/css';

export const calendarYearSelectRecipe = cva({
  base: {
    position: 'relative',
    display: 'flex',
    paddingInlineStart: 'tightest',
  },
  variants: {
    disabled: {
      true: {
        cursor: 'default',
        opacity: 'disabled',
      },
      false: {
        cursor: 'pointer',
      },
    },
  },
});
